import { observer } from 'mobx-react';
import * as React from 'react';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import strings from 'owa-strings/owa-options-strings';
import { fetchAndValidateDomain } from '../actions/fetchAndValidateDomain';
import { startDomainEnroll } from '../actions/startDomainEnroll';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { OptionDescription } from 'owa-options-controls';
import { getSubscriberType } from '../actions/getSubscriberType';
import { SubscriberType } from '../contracts/subscriberType';
import { getPremiumUser } from '../actions/getPremiumUser';
import { createEmail } from '../actions/createEmail';
import store from '../store/store';
import { format } from 'owa-strings';

const styles = require('./DomainEnrollOptionFull.scss');

var personalizedEmailDescriptionString;
var renderComponent;

@observer
export default class DomainEnrollOptionFull extends React.Component<{}, {}> {
    componentDidMount() {
        getPremiumUser();
        fetchAndValidateDomain();
        getSubscriberType();
    }

    render() {
        if (store.subscriberType == SubscriberType.Primary && !store.domainState.isDomainCreated) {
            personalizedEmailDescriptionString = strings.options_premiumSubOption_EnrollDomain;
            renderComponent = true;
        } else if (
            store.subscriberType == SubscriberType.Secondary &&
            !store.userInfo.isProsumerConsumerMailbox &&
            store.domainState.isValid
        ) {
            personalizedEmailDescriptionString = format(
                strings.options_premium_GetStartedStringForSecondaryUser,
                store.domainState.domainName
            );
            renderComponent = true;
        } else {
            renderComponent = false;
        }

        return (
            renderComponent && (
                <div className={styles.enrollDomain_container}>
                    <div className={styles.enrollDomain_description}>
                        <OptionDescription>{personalizedEmailDescriptionString}</OptionDescription>
                        <Link href="https://go.microsoft.com/fwlink/?linkid=871933" target="_blank">
                            {strings.options_premium_AdvancedSecurityContent_LearnMore}
                        </Link>
                    </div>
                    <div className={styles.domain_btn_container}>
                        <PrimaryButton
                            text={strings.options_premiumSubOption_GetStarted}
                            data-is-focusable={true}
                            disabled={false}
                            onClick={
                                store.subscriberType == SubscriberType.Primary
                                    ? startDomainEnroll
                                    : createEmail
                            }
                        />
                    </div>
                </div>
            )
        );
    }
}
